// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Debe coincidir con Sidebar: estado inicial isCollapsed=true → 80px */
:root {
  --app-sidebar-width: 80px;
}

.app-layout {
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #1a1a1a;
}

/* Grid: columna 1 = sidebar, columna 2 = header + contenido (evita solapes con position:fixed) */
.app-layout-grid {
  display: grid;
  grid-template-columns: var(--app-sidebar-width, 80px) minmax(0, 1fr);
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  transition: grid-template-columns 0.3s ease;
}

.app-main-stack {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
}

.layout-content {
  position: relative;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #0a0a0a;
  margin: 0 !important;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Pantalla completa en Ver Stream */
body.streaming-fullscreen .app-layout-grid {
  grid-template-columns: minmax(0, 1fr);
}

body.streaming-fullscreen .app-layout-grid .sidebar {
  display: none !important;
}

body.streaming-fullscreen .app-main-stack {
  grid-column: 1 / -1;
  min-height: 100vh;
  min-height: 100dvh;
}

body.streaming-fullscreen .app-main-stack .app-header {
  display: none !important;
}

body.streaming-fullscreen .layout-content {
  flex: 1 1;
  min-height: 100vh;
  min-height: 100dvh;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iGAAiG;AACjG;EACE,aAAa;EACb,oEAAoE;EACpE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Debe coincidir con Sidebar: estado inicial isCollapsed=true → 80px */\n:root {\n  --app-sidebar-width: 80px;\n}\n\n.app-layout {\n  min-height: 100vh;\n  min-height: 100dvh;\n  background-color: #1a1a1a;\n}\n\n/* Grid: columna 1 = sidebar, columna 2 = header + contenido (evita solapes con position:fixed) */\n.app-layout-grid {\n  display: grid;\n  grid-template-columns: var(--app-sidebar-width, 80px) minmax(0, 1fr);\n  min-height: 100vh;\n  min-height: 100dvh;\n  width: 100%;\n  transition: grid-template-columns 0.3s ease;\n}\n\n.app-main-stack {\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n.layout-content {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #0a0a0a;\n  margin: 0 !important;\n  padding: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Pantalla completa en Ver Stream */\nbody.streaming-fullscreen .app-layout-grid {\n  grid-template-columns: minmax(0, 1fr);\n}\n\nbody.streaming-fullscreen .app-layout-grid .sidebar {\n  display: none !important;\n}\n\nbody.streaming-fullscreen .app-main-stack {\n  grid-column: 1 / -1;\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\nbody.streaming-fullscreen .app-main-stack .app-header {\n  display: none !important;\n}\n\nbody.streaming-fullscreen .layout-content {\n  flex: 1;\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
